"use client";

import type React from "react";
import { createContext, useContext, useState } from "react";

interface FolderContextType {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  folders: any[];
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  setFolders: React.Dispatch<React.SetStateAction<any[]>>;
  activeFolderId: string | null;
  setActiveFolderId: React.Dispatch<React.SetStateAction<string | null>>;
}

export const FolderContext = createContext<FolderContextType>({
  folders: [],
  setFolders: () => {},
  activeFolderId: null,
  setActiveFolderId: () => {},
});

export function FolderProvider({ children }: { children: React.ReactNode }) {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  const [folders, setFolders] = useState<any[]>([]);
  const [activeFolderId, setActiveFolderId] = useState<string | null>(null);

  return (
    <FolderContext.Provider value={{ folders, setFolders, activeFolderId, setActiveFolderId }}>
      {children}
    </FolderContext.Provider>
  );
}

export const useFolderContext = () => useContext(FolderContext);
